import { useState } from "react";
import { FileText, ShieldCheck, MessageCircle, ChevronDown, X } from "lucide-react";
import BottomSheet from "@/components/BottomSheet";

function LegalCapsule({ icon: Icon, title, text, testid, open, onToggle }) {
  if (!text) return null;
  return (
    <div data-testid={testid} className="overflow-hidden rounded-3xl bg-white/10">
      <button
        data-testid={`${testid}-toggle`}
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left text-white active:scale-[0.99]"
      >
        <span className="flex items-center gap-2">
          <Icon className="h-5 w-5 shrink-0" strokeWidth={1.7} />
          <span className="font-brand text-base font-normal">{title}</span>
        </span>
        <ChevronDown
          className={`h-5 w-5 shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
          strokeWidth={2}
        />
      </button>
      <div
        className="grid transition-all duration-300 ease-out"
        style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
      >
        <div className="overflow-hidden">
          <p className="max-h-[46vh] overflow-y-auto overscroll-contain whitespace-pre-wrap px-5 pb-5 text-sm leading-relaxed text-white/80">{text}</p>
        </div>
      </div>
    </div>
  );
}

export default function SettingsSheet({ open, onOpenChange, config }) {
  const [openKey, setOpenKey] = useState(null);
  const toggle = (k) => setOpenKey((prev) => (prev === k ? null : k));

  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} className="safe-bottom rounded-t-[34px] bg-white px-6 pb-8">
      <div data-testid="settings-sheet" className="pt-4">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="font-brand text-xl font-normal text-white">Información</h2>
          <button
            data-testid="close-settings-btn"
            onClick={() => onOpenChange(false)}
            className="grid h-9 w-9 place-items-center rounded-full bg-white/20 text-white"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-3">
          <LegalCapsule
            icon={FileText}
            title="Términos y condiciones"
            text={config?.terms}
            testid="terms-capsule"
            open={openKey === "terms"}
            onToggle={() => toggle("terms")}
          />
          <LegalCapsule
            icon={ShieldCheck}
            title="Política de privacidad"
            text={config?.privacy}
            testid="privacy-capsule"
            open={openKey === "privacy"}
            onToggle={() => toggle("privacy")}
          />

          <section className="pt-2">
            <div className="mb-2 flex items-center gap-2 text-white">
              <MessageCircle className="h-5 w-5" strokeWidth={1.7} />
              <h3 className="font-brand text-base font-normal">Contáctanos</h3>
            </div>
            {config?.contact && <p className="whitespace-pre-wrap text-sm leading-relaxed text-white/80">{config.contact}</p>}
            {config?.contact_whatsapp && (
              <a
                data-testid="contact-whatsapp-btn"
                href={`https://wa.me/${String(config.contact_whatsapp).replace(/[^0-9]/g, "")}`}
                target="_blank"
                rel="noreferrer"
                className="mt-3 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white active:scale-95"
                style={{ backgroundColor: "#5C5CF2" }}
              >
                <img src="/assets/whatsapp.png" alt="" className="h-4 w-4 shrink-0 object-contain" style={{ filter: "brightness(0) invert(1)" }} /> WhatsApp
              </a>
            )}
          </section>
        </div>
      </div>
    </BottomSheet>
  );
}
